import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RealtimeProvider } from "../../realtime/realtime-database";
import { fetchCompanyPlan } from "../../store/company/company-actions";
import {
  fetchEventData,
  fetchEventTracks,
} from "../../store/event/event-actions";
import { Container } from "./sidebars-styled";
import SideBarLeft from "./sidebars/sidebar-left";
import { AppState } from "../../store/app-state";
import Tour from "reactour";
import { useQuery } from "../../hooks";
import { useTourContext } from "../../hooks/user-tour";
import Nps from "../../components/nps";
import AccountConfirmation from "../../components/account-confirmation";

const TALENT_EVENT_SLUG = "talent-match";

const SideBarsLayout: React.FC = ({ children }) => {
  const dispatch = useDispatch();
  const [isOpenLeft, setIsOpenLeft] = useState<boolean>(false);
  const { token, user } = useSelector((state: AppState) => state.authState);
  const { showNps } = useSelector((state: AppState) => state.npsState);
  const [isTourOpen, setIsTourOpen] = useState(false);
  const [query, setQuery] = useQuery<{ tour: string }>();
  const [step, setStep] = useState(0);
  const { steps } = useTourContext();

  useEffect(() => {
    if (token) {
      dispatch(fetchEventData(TALENT_EVENT_SLUG));
      dispatch(fetchEventTracks(TALENT_EVENT_SLUG));
      dispatch(fetchCompanyPlan());
    }
  }, [dispatch, token]);

  useEffect(() => {
    if (query.tour === "true" && !isTourOpen) {
      setIsTourOpen(true);
    } else if (query.tour === "false" && isTourOpen) {
      setIsTourOpen(false);
    }
  }, [query, isTourOpen]);

  return (
    <RealtimeProvider>
      <Container>
        <SideBarLeft isOpen={isOpenLeft} setIsOpen={setIsOpenLeft} />
        <AccountConfirmation show={!user?.is_talent_active} />
        <main>{children}</main>
      </Container>
      <Tour
        steps={steps}
        isOpen={isTourOpen && steps && steps.length > 0}
        onRequestClose={() => {
          setQuery({ ...query, tour: "false" });
          setStep(0);
        }}
        disableDotsNavigation
        accentColor="#552176"
        showNumber={false}
        startAt={0}
        goToStep={step}
        nextStep={() => setStep((prev) => prev + 1)}
        prevStep={() => setStep((prev) => prev - 1)}
        closeWithMask={true}
        disableInteraction={true}
      />
      <Nps show={showNps} />
    </RealtimeProvider>
  );
};

export default SideBarsLayout;
